<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M8.25,20.768c-0.287,0-0.568-0.054-0.835-0.161l-6-2.4C0.555,17.863,0,17.043,0,16.117V1.744
		c-0.001-0.191,0.035-0.381,0.108-0.562C0.257,0.81,0.542,0.519,0.91,0.361C1.099,0.281,1.297,0.24,1.5,0.24
		c0.191,0,0.379,0.036,0.559,0.109l5.913,2.366c0.086,0.034,0.176,0.052,0.267,0.053c0.004,0,0.018,0,0.022,0
		c0.091-0.001,0.182-0.019,0.268-0.054l6.385-2.555c0.268-0.107,0.549-0.162,0.836-0.162c0.287,0,0.568,0.054,0.835,0.162l6,2.4
		C23.445,2.902,24,3.722,24,4.648v4.35c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75v-4.35c0-0.309-0.185-0.582-0.471-0.697
		L16.5,1.74v6.508c0,0.414-0.336,0.75-0.75,0.75S15,8.662,15,8.248V1.74L9.086,4.106C9.057,4.118,9.029,4.128,9,4.139v14.887
		l2.409-0.964c0.089-0.036,0.183-0.054,0.279-0.054c0.308,0,0.582,0.185,0.696,0.471c0.074,0.187,0.072,0.39-0.007,0.574
		s-0.225,0.327-0.411,0.401l-2.881,1.153C8.817,20.714,8.536,20.768,8.25,20.768z M1.5,16.117c0,0.309,0.185,0.582,0.472,0.697
		L7.5,19.025V4.139c-0.029-0.01-0.057-0.021-0.086-0.032L1.501,1.741L1.5,16.117z"/>
	<path d="M18.75,16.948c-0.62,0-1.125-0.505-1.125-1.125c0-0.573,0.427-1.048,0.995-1.115c0.042-0.007,0.086-0.011,0.13-0.011
		s0.088,0.004,0.131,0.011c0.513,0.06,0.923,0.47,0.983,0.983c0.008,0.042,0.011,0.086,0.011,0.131s-0.004,0.088-0.011,0.131
		c-0.06,0.509-0.466,0.918-0.974,0.982C18.843,16.944,18.796,16.948,18.75,16.948z"/>
	<path d="M18.749,23.998c-0.337,0-0.656-0.11-0.922-0.317c-0.097-0.076-0.185-0.164-0.26-0.26c-1.855-2.372-4.067-5.616-4.067-7.598
		c0-2.895,2.355-5.25,5.25-5.25S24,12.927,24,15.822c0,1.979-2.212,5.225-4.068,7.6C19.646,23.788,19.215,23.998,18.749,23.998z
		 M18.75,12.072c-2.068,0-3.75,1.682-3.75,3.75c0,1.161,1.437,3.719,3.75,6.676c2.313-2.959,3.75-5.517,3.75-6.676
		C22.5,13.754,20.818,12.072,18.75,12.072z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'maps-pin-1',
    },
    name: {
      type: String,
      required: false,
      default: 'MapsPin1',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>